var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgPaw = function SvgPaw(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 226 207",
    width: "1em",
    height: "1em",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.356 194.664c-35.276 0-84.534-32.864-63.85-63.202 10.342-15.17 21.505-20.478 32.608-32.142 11.104-11.665 15.53-21.097 30.922-20.896 15.392.202 18.219 9.689 29.21 20.896 10.99 11.206 24.17 16.057 34.96 32.142 21.584 32.17-28.573 63.202-63.85 63.202z",
    opacity: "undefined"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.529,
    cy: 93.509,
    rx: 24.386,
    ry: 34.57
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 193.42,
    cy: 93.509,
    rx: 24.386,
    ry: 34.57
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.18,
    cy: 43.141,
    rx: 24.386,
    ry: 34.57
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 145.083,
    cy: 43.141,
    rx: 24.386,
    ry: 34.57
  })));
};

export { SvgPaw as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9ImN1cnJlbnRDb2xvciIgdmlld0JveD0iMCAwIDIyNiAyMDciPgogICAgPHBhdGggZD0iTTExMi4zNTYgMTk0LjY2NGMtMzUuMjc2IDAtODQuNTM0LTMyLjg2NC02My44NS02My4yMDIgMTAuMzQyLTE1LjE3IDIxLjUwNS0yMC40NzggMzIuNjA4LTMyLjE0MiAxMS4xMDQtMTEuNjY1IDE1LjUzLTIxLjA5NyAzMC45MjItMjAuODk2IDE1LjM5Mi4yMDIgMTguMjE5IDkuNjg5IDI5LjIxIDIwLjg5NiAxMC45OSAxMS4yMDYgMjQuMTcgMTYuMDU3IDM0Ljk2IDMyLjE0MiAyMS41ODQgMzIuMTctMjguNTczIDYzLjIwMi02My44NSA2My4yMDJ6IiBvcGFjaXR5PSJ1bmRlZmluZWQiLz4KICAgIDxlbGxpcHNlIGN4PSIzMS41MjkiIGN5PSI5My41MDkiIHJ4PSIyNC4zODYiIHJ5PSIzNC41NyIvPgogICAgPGVsbGlwc2UgY3g9IjE5My40MiIgY3k9IjkzLjUwOSIgcng9IjI0LjM4NiIgcnk9IjM0LjU3Ii8+CiAgICA8ZWxsaXBzZSBjeD0iNzkuMTgiIGN5PSI0My4xNDEiIHJ4PSIyNC4zODYiIHJ5PSIzNC41NyIvPgogICAgPGVsbGlwc2UgY3g9IjE0NS4wODMiIGN5PSI0My4xNDEiIHJ4PSIyNC4zODYiIHJ5PSIzNC41NyIvPgo8L3N2Zz4=";